import createReducer from "../../../reducers/createReducer";
import { ACTION_GET_USERS } from "./actions";

const INITIAL_STATE = {
  users: [],
};

const UsersManagementReducer = createReducer(INITIAL_STATE, {
  [ACTION_GET_USERS](state, action) {
    return {
      ...state,
      users: [].concat(action.payload),
    };
  },
});

export default UsersManagementReducer;
